import React from 'react';
import PropTypes from "prop-types";

import './progress_bar.scss';
import {getRangeArrayFromNumber} from "../../../utils/content";

function ProgressBar({index, no_cards, no_bonus_cards}) {
    function getTileClass(current_index) {
        if ((current_index + 1 === no_cards && current_index === index) || (current_index < index && current_index + 1 > no_cards - no_bonus_cards)) {
            return 'bonus-done';
        } else if (current_index === index) {
            return 'current';
        } else if (current_index < index) {
            return 'done';
        } else {
            return 'to-do';
        }
    }

    function renderCompletionItem(current_index) {
        return (
            <div key={current_index} className={'mindsets-progress-bar-item ' + getTileClass(current_index)}>&nbsp;</div>
        );
    }

    return (
        <div>
            <div className='mindsets-progress-bar'>
                {getRangeArrayFromNumber(no_cards - no_bonus_cards).map((item, current_index) => renderCompletionItem(current_index))}
                {getRangeArrayFromNumber(no_bonus_cards).map((item, current_index) => renderCompletionItem(no_cards - no_bonus_cards + current_index))}
            </div>
        </div>
    );
}

ProgressBar.propTypes = {
    index: PropTypes.number.isRequired,
    no_cards: PropTypes.number.isRequired,
    no_bonus_cards: PropTypes.number.isRequired
};

export default ProgressBar;
